import { ALERT_CREATION_ROUTE_NAME, 
  ALERT_DETAILS_ROUTE_NAME,
  ALERTS_LIST_ROUTE_NAME,
  ALERTS_OVERVIEW_ROUTE_NAME,
  ALERTS_ROUTE_NAME } from 'frontend/routes/constants'
import { ALERTS } from 'frontend/constants/callers'
import { ALERTS_SOURCE } from 'frontend/constants/alerts'
import { DASHBOARD_MODULE_TOKENS } from 'frontend/constants/settings'

const HeaderFactoryStructure = () => import('frontend/components/core/HeaderFactoryStructure')
const AlertDetails = () => import('frontend/pages/alerts/AlertDetails')
const AlertsList = () => import('frontend/pages/alerts/AlertsList')
const AlertsPage = () => import('frontend/pages/alerts/AlertsPage')
const RemoteFilters = () => import('frontcore/presentation/remote-filters/views/RemoteFilters.vue')
const AlertsOverview = () => import('frontend/pages/alerts/AlertsOverview')

export default [
  {
    name: ALERTS_ROUTE_NAME,
    path: '/alerts',
    component: AlertsPage,
    redirect: { name: DASHBOARD_MODULE_TOKENS.alertsList.name },
    children: [
      {
        shownInMenu: true,
        path: 'overview',
        name: ALERTS_OVERVIEW_ROUTE_NAME,
        components: {
          default: AlertsOverview,
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
        },
        props: {
          default: { caller: ALERTS, source: ALERTS_SOURCE },
          header: { caller: ALERTS, source: ALERTS_SOURCE },
        },
      },
      {
        shownInMenu: true,
        path: 'list',
        name: ALERTS_LIST_ROUTE_NAME,
        components: {
          default: AlertsList,
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
        },
        props: {
          default: { caller: ALERTS, source: ALERTS_SOURCE },
          header: { caller: ALERTS, source: ALERTS_SOURCE },
        },
      },
      {
        shownInMenu: false,
        path: 'list/new',
        name: ALERT_CREATION_ROUTE_NAME,
        component: AlertDetails,
        props: { source: ALERTS_SOURCE },
      },
      {
        shownInMenu: false,
        path: 'list/:id',
        name: ALERT_DETAILS_ROUTE_NAME,
        component: AlertDetails,
        props: { source: ALERTS_SOURCE },
      },
    ],
  },
]
